// @owners { team: patients-team }
import { NavBarLogo } from '@alto/design-system';
import React from 'react';
import styled from 'styled-components';
import logo from '~shared/assets/images/altoLogo@2x.png';
import progynyLogo from '~shared/assets/images/progyny_by_alto_logo@2x.png';
import getShowProgynySelfServiceForUser from '~shared/features/users/selectors/getShowProgynySelfServiceForUser';
import { useSelectorShared } from '~shared/store';

export type Props = {
  readonly illustrationSrc?: string | null;
  readonly isPartnerLogo?: boolean;
};

const OnboardingAltoLogo = styled.img`
  width: 60px;
  height: 31px;
`;

export const OnboardingNavBarLogo = ({ illustrationSrc, isPartnerLogo = false }: Props) => {
  const showProgyny = useSelectorShared(getShowProgynySelfServiceForUser);

  if (showProgyny) {
    return (
      <NavBarLogo
        height="SM"
        width="XL"
        source={progynyLogo}
        accessibilityLabel="progyny-logo"
      />
    );
  }

  if (isPartnerLogo) {
    return (
      <NavBarLogo
        height="SM"
        width="XL"
        source={illustrationSrc || logo}
        accessibilityLabel="partner-logo"
      />
    );
  }

  return (
    <OnboardingAltoLogo
      src={illustrationSrc || logo}
      alt="alto-logo"
    />
  );
};
